import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';
import OSelect from '../../../../../Components/OElements/OSelect';
import OInput from '../../../../../Components/OElements/OInput';
import {
	getWarehouseList,
	getWarehouseItemList,
} from '../../../../../helpers/warehouse/backend_helper';

export const ItemsSectionInputsEPP = ({ onPrefillBase }) => {
	const validation = useFormikContext();
	const [selectedWarehouse, setSelectedWarehouse] = useState(null);

	return (
		<Row className='g-3'>
			<Col lg={4}>
				<OSelect
					key={`epp_warehouse_${validation.values.establishment_id || ''}`}
					label='Bodega'
					id='epp_warehouse_id'
					name='epp_warehouse_id'
					value={validation.values.epp_warehouse_id || ''}
					onSelect={warehouse => {
						setSelectedWarehouse(warehouse);
					}}
					requestApi={() =>
						getWarehouseList({
							establishment_id:
								validation.values.establishment_id || undefined,
							warehouse_usage_type_code: 'EPP',
						})
					}
					handleLabelOptions={item => item?.name || 'Bodega'}
					validation={validation}
				/>
			</Col>
			<Col lg={6}>
				<OSelect
					key={`epp_items_${
						selectedWarehouse?._id || selectedWarehouse?.value || 'none'
					}`}
					label='Ítem'
					id='epp_item_id'
					name='epp_item_id'
					value={validation.values.epp_item_id || ''}
					onSelect={stockItem => {
						const itemName = stockItem?.name || '';
						const unit = stockItem?.unit_measurement?.name || '';
						const available = Number(stockItem?.available) || 0;
						// Setear stock disponible en Formik para mostrarlo y validar
						validation.setFieldValue('epp_qty_max', available, false);
						onPrefillBase &&
							onPrefillBase({
								NmbItem: itemName,
								UnmdItem: unit.toUpperCase(),
								qtyMax: available,
								VlrCodigo: stockItem?.code_sap || '',
								TpoCodigo: 'INT1',
								PrcItem: stockItem?.price || 0,
							});
					}}
					requestApi={() =>
						selectedWarehouse
							? getWarehouseItemList({
									warehouse_id:
										selectedWarehouse?._id ||
										selectedWarehouse?.value,
									all: false,
							  })
							: Promise.resolve([])
					}
					handleLabelOptions={item =>
						`${item?.name || '-'} || ${item?.available || 0} ${(
							item?.unit_measurement?.name || ''
						).toUpperCase()}`
					}
					validation={validation}
					disabled={!selectedWarehouse}
				/>
			</Col>
			<Col lg={2}>
				<OInput
					name='epp_qty_max'
					label='Stock disponible'
					type='number'
					validation={validation}
					classNameLabel='form-label'
					classNameInput='form-control'
					placeholder='-'
					disabled
					readOnly
				/>
			</Col>
		</Row>
	);
};
